
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyDBqmKoBCkL2uL2LmftFakx-mdVZ3vR51s",
  authDomain: "saarthiphysiotherapy.firebaseapp.com",
  projectId: "saarthiphysiotherapy",
  storageBucket: "saarthiphysiotherapy.firebasestorage.app",
  messagingSenderId: "233884968947",
  appId: "1:233884968947:web:fa2251db4cfdf40b4cd486",
  measurementId: "G-2Z2D4B4XWV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, db };
